/* eslint-disable */
import React from 'react';
import { Alert, AlertTitle } from '@mui/material';

const SUPPORT_EMAIL = 'contact@keyskillset.com';

const ALERT_CONFIG = {
  7: {
    severity: 'warning',
    title: 'Account not activated',
    body: 'No password set yet.',
  },
  8: {
    severity: 'error',
    title: 'Account deactivated',
    body: 'Your account has been deactivated. Please ',
  },
  9: {
    severity: 'info',
    title: 'Password not set',
    body: 'To set Password',
  },
  10: {
    severity: 'info',
    title: 'First time login',
    body: 'Please set your password to continue.',
  },
  11: {
    severity: 'warning',
    title: 'Account not verified',
    body: 'Please verify your email to continue.',
  },
   ORG_DEACTIVATED: {                                       
    severity: 'error',
    title: 'Organisation deactivated',
    body: 'Your organisation account has been deactivated. Please ',
  },     
  USER_SUSPENDED: {
    severity: 'error',
    title: 'Account suspended',
    body: 'Your account has been suspended. Please ',
},
  USER_DEACTIVATED: {
    severity: 'error',
    title: 'Account deactivated',
    body: 'Your account has been deactivated. Please ',
   },
};

export default function StatusAlert({ alert, onForgotPassword, onDismiss }) {
  if (!alert) return null;
  const cfg = ALERT_CONFIG[alert.type];
  if (!cfg) return null;

  return (
    <Alert
      severity={cfg.severity}
      onClose={onDismiss || undefined}
      sx={{ borderRadius: '10px', fontSize: '13px', mt: 1 }}
    >
      <AlertTitle sx={{ fontSize: '13px', fontWeight: 600 }}>{cfg.title}</AlertTitle>
      {cfg.body}
      {(alert.type === 8 || alert.type === 'ORG_DEACTIVATED' || alert.type === 'USER_SUSPENDED' || alert.type === 'USER_DEACTIVATED') && (
        <a
          href={"mailto:" + SUPPORT_EMAIL}
          style={{ fontWeight: 700, color: 'inherit', textDecoration: 'underline' }}
        >
          contact support
        </a>
      )}
      {(alert.type === 7 || alert.type === 9 || alert.type === 10) && (
        <span
          onClick={onForgotPassword}
          style={{ fontWeight: 700, textDecoration: 'underline', cursor: 'pointer' }}
        >
          Click here
        </span>
      )}
    </Alert>
  );
}
